"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.foundation_time = void 0;
exports.foundation_time = {
    fast: {
        time_fast_5ms: '05ms',
        time_fast_10ms: '10ms',
        time_fast_20ms: '20ms',
        time_fast_25ms: '25ms',
        time_fast_30ms: '30ms',
        time_fast_50ms: '50ms',
        time_fast_75ms: '75ms',
        time_fast_100ms: '100ms',
        time_fast_125ms: '125ms',
        time_fast_150ms: '150ms',
    },
    moderate: {
        time_moderate_165ms: '165ms',
        time_moderate_175ms: '175ms',
        time_moderate_200ms: '200ms',
        time_moderate_225ms: '225ms',
        time_moderate_240ms: '240ms',
        time_moderate_250ms: '250ms',
        time_moderate_275ms: '275ms',
        time_moderate_300ms: '300ms',
        time_moderate_325ms: '325ms',
        time_moderate_330ms: '330ms',
        time_moderate_350ms: '350ms',
        time_moderate_365ms: '365ms',
        time_moderate_375ms: '375ms',
        time_moderate_400ms: '400ms',
        time_moderate_425ms: '425ms',
        time_moderate_435ms: '435ms',
        time_moderate_450ms: '450ms',
        time_moderate_460ms: '460ms',
        time_moderate_475ms: '475ms',
        time_moderate_500ms: '500ms',
        time_moderate_525ms: '525ms',
        time_moderate_550ms: '550ms',
        time_moderate_575ms: '575ms',
    },
    slow: {
        time_slow_600ms: '600ms',
        time_slow_625ms: '625ms',
        time_slow_650ms: '650ms',
        time_slow_675ms: '675ms',
        time_slow_700ms: '700ms',
        time_slow_725ms: '725ms',
        time_slow_750ms: '750ms',
        time_slow_775ms: '775ms',
        time_slow_800ms: '800ms',
        time_slow_825ms: '825ms',
        time_slow_850ms: '850ms',
        time_slow_875ms: '875ms',
        time_slow_900ms: '900ms',
        time_slow_925ms: '925ms',
        time_slow_950ms: '950ms',
        time_slow_975ms: '975ms',
        time_slow_1s: '1s',
        time_slow_2s: '2s',
        time_slow_3s: '3s',
        time_slow_4s: '4s',
        time_slow_5s: '5s',
        time_slow_none: 'unset',
    },
};
//# sourceMappingURL=time.js.map